import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=51bdd5ca&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=51bdd5ca&prod&lang=scss"
import style1 from "./CreateGroup.vue?vue&type=style&index=1&id=51bdd5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bdd5ca",
  null
  
)

export default component.exports